import React, { FC } from 'react'

import { GridBreakpoints, GridProps } from './Grid.types'

import { Container } from './Grid.styles'

const DEFAULT_GUTTER: GridBreakpoints = {
  xl: 40,
  lg: 20,
  md: 20,
  sm: 20,
  xs: 16,
}

const DEFAULT_ROW_GAP: GridBreakpoints = {
  xl: 64,
  lg: 64,
  md: 64,
  sm: 32,
  xs: 32,
}

export const Grid: FC<GridProps> = ({
  children,
  gutter = DEFAULT_GUTTER,
  // TODO: Review why this field is unused
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  gridRowGap = DEFAULT_ROW_GAP,
  asList,
  ...props
}) => {
  return (
    <Container as={asList ? 'ul' : undefined} gutter={gutter} {...props}>
      {children}
    </Container>
  )
}
